import store from "@/store";
import request from "@/utils/request";


export async function getStudyCheck(params) {
    console.log("@@ get list : getStudyCheck");
    let result = request.get("/api/check/checkStudy/",{params});
    return result;
}
export async function saveCheckStudy(params) {
    console.log("@@ post save : saveCheckStudy");
    let result = request.post(`/api/check/checkStudy/list/`,params);
    return result;
}
export async function getStudyLmTextBook(params) {
    console.log("@@ get list : getStudyLmTextBook");
    let result = request.get("/api/lm/lmTextBook/",{params});
    return result;
}
export async function getStudyLmTextBookDepth1(params) {
    console.log("@@ get list : getStudyLmTextBookDepth1");
    let result = request.get("/api/cs/csCont/",{params});
    return result;
}

export async function getStudyLmTextBookDepth2(params) {
    console.log("@@ get list : getStudyLmTextBookDepth2");
    let result = request.get("/api/cs/csCont/tree/list/",{params});
    return result;
}

export async function setStudyCheckFile(params) {
    console.log("@@ get list : setStudyCheckFile");
    let result = request.post("/api/check/checkStudy/list",params);
    return result;
}

export async function setStudyCheckOnlineFile(params) {
    console.log("@@ get list : setStudyCheckOnlineFile");
    let result = request.post("/api/check/checkStudy/onlineContentsList",params);
    return result;
}

export async function uploadStudyCheckFile(params) {
    console.log("@@ get list : uploadStudyCheckFile");
    let result = request.post("/api/check/checkStudy/",params);
    return result;
}

export async function getFindStudyCheckFile(params) {
    console.log("@@ get list : uploadStudyCheckFile");
    let result = request.get("/api/check/checkStudy/csFileList",{params});
    return result;
}
